<script>
import ModalDialog from './ModalDialog.vue'
import ErrorText from '../Text/ErrorText.vue'

export default {
  components: { ErrorText, ModalDialog },
  props: {
    id: {
      type: String,
      required: true,
    },
    errors: {
      type: Array,
      required: true,
      validator: (errors) => errors.length > 0,
    },
  },
  methods: {
    open() {
      if (this.$refs['modal']) {
        this.$refs['modal'].open()
      }
    },
    close() {
      if (this.$refs['modal']) {
        this.$refs['modal'].close(false)
      }
    },
  },
}
</script>
<template>
  <ModalDialog :id="id" ref="modal" class-content="bg-pale-danger" :show-header="false" e2e-modal="error">
    <ErrorText>
      <ul>
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
    </ErrorText>
  </ModalDialog>
</template>
